import React from "react";
import TextField from "@mui/material/TextField";

const PeopleInput = ({ onPeopleChange, disabled, sx }) => {
  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value > 0) {
      onPeopleChange(value);
    } else {
      onPeopleChange(null); // Set to null or some other falsy value when not valid
    }
  };

  const sxArray = Array.isArray(sx) ? sx : sx ? [sx] : [];
  const baseSx = {
    backgroundColor: "rgba(245, 255, 245, 0.06)",
    borderRadius: "18px",
    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(245, 255, 245, 0.1)",
    },
    "& .MuiOutlinedInput-root": {
      color: "#F5FFF5",
      "& fieldset": {
        borderColor: "rgba(245, 255, 245, 0.35)",
      },
      "&:hover fieldset": {
        borderColor: "#B8FFDA",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#B8FFDA",
        boxShadow: "0 0 0 2px rgba(184, 255, 218, 0.25)",
      },
      "&.Mui-disabled fieldset": {
        borderColor: "rgba(245, 255, 245, 0.2)",
      },
    },
    "& .MuiInputBase-input": {
      color: "#F5FFF5",
      paddingTop: "14px",
      paddingBottom: "14px",
      fontWeight: 500,
      "&::placeholder": {
        color: "rgba(245, 255, 245, 0.8)",
        opacity: 1,
      },
      "&.Mui-disabled": {
        color: "rgba(245, 255, 245, 0.55)",
      },
    },
    "& .MuiInputLabel-root": {
      color: "rgba(245, 255, 245, 0.85)",
      fontWeight: 600,
      letterSpacing: "0.02em",
      "&.Mui-focused": {
        color: "#B8FFDA",
      },
      "&.Mui-disabled": {
        color: "rgba(245, 255, 245, 0.55)",
      },
    },
    "& .MuiFormHelperText-root": {
      color: "rgba(245, 255, 245, 0.75)",
      marginLeft: 0,
      marginRight: 0,
    },
  };
  const combinedSx = [baseSx, ...sxArray];

  return (
    <TextField
      type="number"
      required
      disabled={disabled}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        inputProps: { min: 1 },
      }}
      onChange={handleChange}
      label="Number of People"
      variant="outlined"
      placeholder="E.g. 4 travelers"
      fullWidth
      helperText="We can accommodate groups of up to 12 guests per vehicle."
      FormHelperTextProps={{
        sx: { marginLeft: 0 },
      }}
      sx={combinedSx}
    />
  );
};

export default PeopleInput;
